import React from 'react';
import PropTypes from 'prop-types';

import Style from './settingsForm.module.css';
import { useTranslation } from 'react-i18next';
import { Form, Icon, TooltipHelp, CheckboxLabel, Counter, RadioLabel } from '@weezevent/nacre';
import TaxModel from '../../../../models/taxModel';
import SelectTaxes from '../../../../components/tax/selectTaxes';
import LoadingCard from '../../../../components/loadingCard';

export default function SettingsForm({ form = {}, onChangeForm = () => {}, formErrors, globalSells = 0 }) {
    const { t } = useTranslation();
    const [taxes, loading] = TaxModel.useApiModel({});

    const onChangeUnlimitedQuantity = React.useCallback(
        (e, { value, checked }) => {
            if (!checked) {
                onChangeForm('quota', 0);
            } else {
                onChangeForm('quota', null);
            }
        },
        [onChangeForm]
    );

    const onChangeTax = React.useCallback(
        (name, value) => {
            onChangeForm(name, value === 'event' ? null : value);
        },
        [onChangeForm]
    );

    return (
        <div className={Style['settings-form']}>
            <LoadingCard loading={loading}>
                <Form.Field className={Style['session-form-field-wo-margin']}>
                    <Form.Label label={t('ticket.sessions.detail.settings.enabledLabel')} />
                    <div>
                        <RadioLabel
                            className={Style['radio-label-custom']}
                            active={form.enabled}
                            inline
                            bordered
                            name={'enable'}
                            checked={form.enabled}
                            label={
                                <span>
                                    {t('ticket.sessions.detail.settings.enabled')} <Icon name="eye" />
                                </span>
                            }
                            onClick={() => {
                                onChangeForm('enabled', true);
                            }}
                        />
                        <RadioLabel
                            className={Style['radio-label-custom']}
                            active={!form.enabled}
                            inline
                            bordered
                            name={'disable'}
                            checked={!form.enabled}
                            label={
                                <span>
                                    {t('ticket.common.action.hide-online')} <Icon name="eye-slash" />
                                </span>
                            }
                            onClick={() => {
                                onChangeForm('enabled', false);
                            }}
                        />
                    </div>
                </Form.Field>
                <SelectTaxes
                    label={
                        <span>
                            {t('ticket.common.taxRate')}
                            <TooltipHelp title={t('ticket.sessions.detail.settings.taxTooltip')} />
                        </span>
                    }
                    taxes={taxes}
                    onChange={(optionValue, option) => onChangeTax('tax_id', optionValue)}
                    value={form.tax_id === null ? 'event' : form.tax_id}
                    withOptionTaxEvent
                />
                <Form.Field className={Style['session-form-field-wo-margin']}>
                    <Form.Label>{t('ticket.sessions.detail.settings.quota')}</Form.Label>
                    <div className={Style['container-quota']}>
                        <Counter
                            placeholder={0}
                            onChange={(event, value) => onChangeForm('quota', value)}
                            disabled={form.quota === null}
                            value={form.quota}
                            min={0}
                            errors={formErrors?.quota ? true : false}
                        />
                        <CheckboxLabel
                            onChange={onChangeUnlimitedQuantity}
                            checked={form.quota === null}
                            label={t('ticket.sessions.detail.settings.unlimitedQuota')}
                            name={'unlimited_quota'}
                            value={form.quota === null}
                        />
                    </div>
                    <span>{t('ticket.rates.groupModal.quotaQuantity', { min: globalSells, max: t('ticket.rates.groupModal.noLimit') })}</span>
                    <Form.FieldErrors errors={[formErrors?.quota ?? null]} />
                </Form.Field>
            </LoadingCard>
        </div>
    );
}

SettingsForm.propTypes = {
    form: PropTypes.object,
    onChangeForm: PropTypes.func
};
